import React from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { toast } from '../../../core/lib/toastAlert';

const PlanChoosePopup = (props) => {
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter-sub"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter-sub" style={{
                    color: '#FFF',
                    fontFamily: "Open Sans",
                    fontSize: '18px',
                    fontStyle: 'normal',
                    fontWeight: 600,
                    lineHeight: 'normal'
                }}>
                    Earn Plan {props.plan === '1' ? 'One' : props.plan === '2' ? 'Two' : ''}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <form className='stake-submit'>
                        <label>USDT Amount *</label> <br />
                        <input type='number' placeholder='Minimum 500 USDT' value={props.planAmount1} onChange={(e) => props.setPlanAmount1(e.target.value)} onBlur={(e) => {
                            if (e.target.value % 500 !== 0) {
                                props.setPlanAmount1(() => 0);
                                toast({ type: 'error', message: "Multiple of 500 Only" })
                            }
                        }} /><br />
                        {props?.myProfile?.referralId ? null : <><label className='mt-2'>Referral Code *</label><br />
                            <input type='text' value={props.referralId} onChange={(e) => props.setReferralId(e.target.value)} /></>}
                        <div>
                            {/* <p className='py-2'>{props.plan === '1' ? 'YOU WILL GET 100 % Profit After 18 Months Locking Period' : props.plan === '2' ? 'YOU WILL GET 72% Profit For 24 Months Locking Period With Monthly Claim' : ''}</p> */}
                        </div>
                        <div className='text-center'>
                            <Button onClick={() => {
                                props.submitStakeTrade()
                            }
                            } className='px-5 mt-2' disabled={props.loading}>{props.loading ? '...Loading' : 'Confirm'}</Button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PlanChoosePopup;